export const ProgramCardShimmer: React.FC = () => (
    <div className="my-3 d-flex">
        <div className="col-10 col-md-11 d-flex no-text-decoration position-relative px-0 pr-1 pr-md-2">
            <div className="card m-0 w-100">
                <div className="layout-2-sides program-card text-center">
                    <div className="card-body py-3">
                        <div className="row no-gutters">
                            <div className="col-md-4 col-7 d-flex justify-content-left align-items-center p-0 px-md-2">
                                <div className="d-flex bg-logo justify-content-center align-items-center ml-1 ml-md-2">
                                    <div className="shimmer logo"></div>
                                </div>
                                <div className="icon-vs mx-1 mx-md-2">-</div>
                                <div className="d-flex bg-logo justify-content-center align-items-center">
                                    <div className="shimmer logo"></div>
                                </div>
                            </div>
                            <div className="col-md-8 col-5  d-flex match-content flex-column match-content">
                                <div className="pr-2 pr-md-3 text-rtl">
                                    <h1 className="match-title text-align-right text-right shimmer"> </h1>
                                    <span className="btn-sport-name text-right float-right shimmer"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="col-2 col-md-1 card px-0 m-0 d-flex justify-content-center align-items-center">
            <div className="program-card indicator-list">
                <div className="card-body py-2">
                    <label className="m-0 time-shimmer shimmer">
                    </label>
                </div>
            </div>
        </div>
    </div>
);